export default __webpack_public_path__ + "assets/_Chapters/EPLSystem/e-pls-system.webp";